import { ReactElement } from 'react';
import { Typography, Box } from '@mui/material';
import { Bar as BarChart } from 'react-chartjs-2';

import LoadingFallback from '~components/LoadingFallback';

import { useReportsVisitsSectionContext } from '../../Context';

import { ReportsVisitsSectionChartsWrapperChart } from '../styles';

import { getVisitsPerDayChartProps } from './utils';

const ReportsVisitsSectionChartVisitsPerDay = (): ReactElement => {
  const {
    data: {
      summary: { data: summaryData, loading: loadingSummaryData },
    },
  } = useReportsVisitsSectionContext();

  return (
    <ReportsVisitsSectionChartsWrapperChart>
      <Typography variant="body1" component="h4" fontWeight="bold">
        Visitas por día
      </Typography>

      {loadingSummaryData && <LoadingFallback />}

      {!loadingSummaryData && summaryData && (
        <Box maxHeight={302}>
          <BarChart
            {...getVisitsPerDayChartProps(
              summaryData.reportRouteSummaryItemsCountByState,
            )}
          />
        </Box>
      )}
    </ReportsVisitsSectionChartsWrapperChart>
  );
};

export default ReportsVisitsSectionChartVisitsPerDay;
